import React, {CSSProperties} from "react";
import {Station} from "../../../services/stations/station.service.interface";
import {observer} from "mobx-react";
import {useServices} from "../../../hooks/use-services.hook";

const StationNameBox: React.FC<{stationName: string}> = observer((props) => {
    const services = useServices();
    const styles: CSSProperties = {
        display: 'flex',
        flexDirection: "row",
        justifyContent: 'center',
        alignItems: "center",
        fontSize: services.theme.currentTheme.fontSize.h2,
        fontWeight: services.theme.currentTheme.fontWeight.bold,
        width: '100%',
        textAlign: 'center'
    };

    return (
        <div style={styles}>
            {props.stationName}
        </div>
    );
})

export const StationCodeBox: React.FC<{stationCode: string}> = observer((props) => {
    const services = useServices();
    const styles: CSSProperties = {
        fontSize: services.theme.currentTheme.fontSize.h2,
        fontWeight: services.theme.currentTheme.fontWeight.bold
    };

    return (
        <div style={styles}>
            {props.stationCode}
        </div>
    );
})

const DepartureDateAndTime: React.FC<{departureDate: string; departureTime: string}> = observer((props) => {
    const services = useServices();
    const styles: CSSProperties = {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: services.theme.currentTheme.spacing.flexGap12,
        whiteSpace: 'nowrap'
    };

    return (
        <div style={styles}>
            <span>{props.departureDate}</span>
            <span>|</span>
            <span>{props.departureTime}</span>
        </div>
    )
})

export const TicketStationComponent: React.FC<{station: Station; departureDate: string; departureTime: string}> = observer((props) => {

    const services = useServices();
    const styles: CSSProperties = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: services.theme.currentTheme.spacing.flexGap12
    };

    return (
        <div style={styles}>
            <StationNameBox stationName={props.station.stationName}/>
            <StationCodeBox stationCode={props.station.stationCode}/>
            <DepartureDateAndTime departureDate={props.departureDate} departureTime={props.departureTime}/>
        </div>
    )
})